import { render } from "./PresaleSection.vue?vue&type=template&id=8dcd771a"
import script from "./PresaleSection.vue?vue&type=script&lang=js"
export * from "./PresaleSection.vue?vue&type=script&lang=js"

import "./PresaleSection.vue?vue&type=style&index=0&id=8dcd771a&lang=scss"
script.render = render

export default script